import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PageNavigationItem } from 'app/shared/services/data-services/navigation/navigation.interface';
import { NavigationService } from '../../services/data-services/navigation/navigation.service';
import { PageNavigationService } from 'app/shared/services/page-navigation/page-navigation.service';
import { CustomNavigationTitleService } from 'app/shared/services/custom-nav-title/custom-nav-title.service';
import { LayoutService } from '../../services/layout/layout.service';

@Component({
  selector: 'app-page-navigation',
  templateUrl: './page-navigation.component.html',
  styleUrls: ['./page-navigation.component.scss'],
  standalone: false,
})
export class PageNavigationComponent implements OnInit, OnChanges {
  @Input() items: PageNavigationItem[];
  @Input() mobileStyle: string;
  @Input() inCard = false;
  @Input() showTitle: string = '';
  @Input() statusColor: number;
  @Output() activeChanged: EventEmitter<any> = new EventEmitter();

  isNewEvent = false;
  isMobile = this.pageNavigationService.isMobile;

  public isOpened: boolean;
  public itemLabels: string[];
  public selectedLabel: string;

  private titleMapper = {
    portfolio: this.pageNavigationService.portfolioTitle,
    park: this.pageNavigationService.parkTitle,
    turbine: this.pageNavigationService.turbineTitle,
  };

  readonly headerPortal$ = this.layoutService.headerPortal$;

  constructor(
    private navigationService: NavigationService,
    private router: Router,
    private pageNavigationService: PageNavigationService,
    private customnavTitleService: CustomNavigationTitleService,
    private layoutService: LayoutService,
  ) {}

  get title() {
    return (
      this.customnavTitleService.getCustomTitle() ||
      (this.showTitle && this.titleMapper[this.showTitle] ? this.titleMapper[this.showTitle]() : '')
    );
  }

  ngOnInit() {
    this.updateStoredPageItems();
    this.itemLabels = this.items.map(item => {
      if (item.active) {
        this.selectedLabel = item.name;
      }
      return item.name;
    });

    const itemFromUrl = this.getActiveItemFromUrl();

    if (itemFromUrl) {
      this._activateItem(itemFromUrl);
    }

    this.navigationService.getIsInNewPlanEvent().subscribe(value => {
      this.isNewEvent = value;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.itemLabels = this.items.map(item => {
        if (item.active) {
          this.selectedLabel = item.name;
        }
        return item.name;
      });
    }
  }

  get activeIndex(): number {
    return this.items?.findIndex(item => item.active) ?? 0;
  }

  public setActive(item: PageNavigationItem) {
    this._activateItem(item);
  }

  public onMobileTabChange(event: { index: number }): void {
    this.setActive(this.items[event.index]);
  }
  public changeSelectedSection({ index, option }) {
    this.setActive(this.items[index]);
    this.selectedLabel = option;
  }

  private _activateItem(item: PageNavigationItem) {
    this.items.forEach(el => {
      el.active = el.id === item.id;
      if (el.id === item.id) this.selectedLabel = el.name;
    });
    this.updateStoredPageItems();
    this.activeChanged.emit(item);
  }

  private updateStoredPageItems() {
    const isPrimaryNavigationTab = typeof this.items[0]?.id !== 'number';
    if (isPrimaryNavigationTab) this.navigationService.setPageItems(this.items);
  }

  private getActiveItemFromUrl(): PageNavigationItem | null {
    const segments = this.router.url.split('?')[0].split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1];
    const found = this.items.find(item => String(item.id) === lastSegment);
    return found && !found.active ? found : null;
  }
}
